import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-patient-share-files',
    templateUrl: './patient-share-files.component.html',
    styleUrls: ['./patient-share-files.component.scss'],
    standalone: false
})
export class PatientShareFilesComponent {
  constructor() { }
}
